import React from "react";
import { Check } from "lucide-react";
import { toInt } from "../../pages/UserTest/testUtils";

/**
 * MultipleChoiceQuestion
 * Selectable cards that support multiple selections. `selectedOptionIds`
 * is an array of answerOptionIds; onToggle(optionId) flips membership.
 * Note: this question type does NOT auto-advance on selection (the person
 * needs to pick more than one), so the page shows a "Continue" affordance
 * in the footer instead.
 */
const MultipleChoiceQuestion = ({
  question,
  selectedOptionIds = [],
  onToggle,
}) => {
  const selectedSet = new Set(selectedOptionIds.map(toInt));

  return (
    <div
      className="choice-question"
      role="group"
      aria-label={question.questionText}
    >
      {(question.answerOptions || []).map((option) => {
        const optId = toInt(option.answerOptionId);
        const isSelected = optId != null && selectedSet.has(optId);

        return (
          <button
            key={option.answerOptionId}
            type="button"
            role="checkbox"
            aria-checked={isSelected}
            className={`choice-card mode-multi ${isSelected ? "selected" : ""}`}
            onClick={() => optId != null && onToggle(optId)}
          >
            <span className="choice-indicator">
              <Check />
            </span>
            <span className="choice-label">{option.answerText}</span>
          </button>
        );
      })}
    </div>
  );
};

export default MultipleChoiceQuestion;
